<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '100px'">
      <el-form-item label="URL地址" prop="url">
        <el-input v-model="dataForm.url" placeholder="请输入URL地址" maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="URL名称" prop="urlName">
        <el-input v-model="dataForm.urlName" placeholder="请输入URL名称" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="URL类型" prop="urlType">
        <el-select v-model="dataForm.urlType" placeholder="请选择URL类型" style="width: 100%">
          <el-option
            v-for="item in urlTypeList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="urlSort">
        <el-input-number v-model="dataForm.urlSort" :min="0" :max="9999" placeholder="排序" style="width: 100%"></el-input-number>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">禁用</el-radio>
          <el-radio :label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="dataForm.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          maxlength="500">
        </el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      urlTypeList: [
        { dictLabel: 'H5地址', dictValue: '0' },
        { dictLabel: '下载地址', dictValue: '1' }
      ],
      dataForm: {
        id: '',
        url: '',
        urlName: '',
        urlType: '',
        urlSort: 0,
        status: 1,
        remark: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { type: 'url', message: '请输入正确的URL格式', trigger: 'blur' }
        ],
        urlName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        urlType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        urlSort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { type: 'number', message: '排序必须为数字', trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/appurl/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/appurl', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
